import { axios } from '../../clients/axios'
import { dayjs, MMDDYYYY } from '../../util/date'
import nodeFormData from 'form-data'
import FileDownload from 'js-file-download'
import {
  parsePaidPaymentStatus,
  parsePaymentCategory,
  parsePaymentStatus
} from '../../config/payment'

const paymentHeaders = [
  { value: 'data-table-expand' },
  { value: 'refNo', text: 'ID' },
  { value: 'date', text: 'Date' },
  { value: 'tenantName', text: 'Tenant', width: '15%' },
  // {value: 'bed', text: 'Bed'},
  { value: 'category', text: 'Category' },
  { value: 'period', text: 'Period' },
  { value: 'dueDate', text: 'Due Date' },
  // {value: 'description', text: 'Description'},
  { value: 'total', text: 'Total' },
  { value: 'amountPaid', text: 'Paid' },
  { value: 'status', text: 'Status' },
  // {value: 'attachments', text: 'Files'},
  { value: 'actions', text: 'Actions' }
]

const userPaymentHeaders = [
  { value: 'data-table-expand' },
  { value: 'refNo', text: 'ID' },
  { value: 'date', text: 'Date' },
  // {value: 'bed', text: 'Bed'},
  { value: 'category', text: 'Category' },
  { value: 'period', text: 'Period' },
  { value: 'dueDate', text: 'Due Date' },
  // {value: 'description', text: 'Description'},
  { value: 'total', text: 'Total' },
  { value: 'amountPaid', text: 'Paid' },
  { value: 'status', text: 'Status' },
  // {value: 'attachments', text: 'Files'},
  { value: 'actions', text: 'Actions' }
  // {value: 'data-table-expand'}
]

const paymentRequestHeaders = [
  { value: 'refNo', text: 'ID' },
  { value: 'date', text: 'Date' },
  { value: 'unitName', text: 'Unit' },
  { value: 'tenantName', text: 'Tenant' },
  { value: 'category', text: 'Category' },
  { value: 'period', text: 'Period' },
  { value: 'dueDate', text: 'Due Date' },
  { value: 'total', text: 'Total' },
  { value: 'status', text: 'Status' }
]

const paidPaymentHeaders = [
  { value: 'data-table-expand' },
  { value: 'refNo', text: 'ID' },
  { value: 'date', text: 'Date' },
  { value: 'unitName', text: 'Unit' },
  { value: 'tenantName', text: 'Tenant' },
  { value: 'category', text: 'Category' },
  { value: 'period', text: 'Period' },
  { value: 'total', text: 'Total' },
  { value: 'amountPaid', text: 'Paid' },
  { value: 'status', text: 'Status' }
]

const transformPayment = (params) => {
  const { raw, aliases, paymentCategories, units = [] } = params
  const alias = aliases.find((a) => a.tenantId === raw.tenantId)
  let bedId = null
  if (
    raw.lease_details &&
    (raw.lease_details.status === 'active' ||
      raw.lease_details.status === 'expired')
  ) {
    bedId = raw.lease_details.bedId
  }
  let payment = { ...raw }

  let paymentCategory = paymentCategories.find(
    ({ value }) => value == raw.category
  )

  const unit = units.find(
    (u) => u.bedId === (raw.lease_details && raw.lease_details.bedId)
  )

  payment.category =
    raw.category && !paymentCategory
      ? '<deleted>'
      : paymentCategory && paymentCategory.text //it's a deleted category if there's a raw category but can't be found in the current list of categories
  payment.rawCategory = raw.category

  payment.tenantId = parseInt(raw.tenantId)
  payment.paymentId = parseInt(raw.paymentId)
  payment.refNo = parseInt(raw.refNo)
  payment.date = dayjs(raw.date).format(MMDDYYYY)
  payment.dateUpdated = raw.dateUpdated
    ? dayjs(raw.dateUpdated).format(MMDDYYYY)
    : null
  payment.tenantName =
    (alias && alias.name) ||
    (raw.tenant_details &&
    raw.tenant_details.firstName &&
    raw.tenant_details.lastName
      ? raw.tenant_details.firstName + ' ' + raw.tenant_details.lastName
      : raw.tenant_details && raw.tenant_details.username) ||
    ''
  payment.username = raw.tenant_details && raw.tenant_details.username
  payment.email = raw.tenant_details && raw.tenant_details.email1
  payment.bedName = raw.bed_details ? raw.bed_details.bedName : ''
  payment.unitName = unit && unit.bedName
  payment.period =
    dayjs(raw.startDate).format(MMDDYYYY) +
    ' - ' +
    dayjs(raw.endDate).format(MMDDYYYY)
  payment.description = raw.description || ''
  payment.total = raw.total
  payment.amountPaid = raw.amountPaid
  payment.status = Number.isInteger(raw.paidPaymentId)
    ? parsePaidPaymentStatus(raw.status)
    : parsePaymentStatus(raw.status)
  payment.raw_status = raw.status
  payment.attachments = raw.attachments || []
  payment.items = raw.items
  payment.paidItems = raw.paidItems || []
  // payment.tenantBalance = raw.bed_details && raw.bed_details.balance
  // payment.bedId = raw.bed_details?raw.bed_details.bedId:-1
  payment.bedId = bedId
  payment.adjustments = raw.adjustments
  payment.dueDate = raw.dueDate ? dayjs(raw.dueDate).format(MMDDYYYY) : ''
  payment.startDate = raw.startDate
  payment.endDate = raw.endDate
  payment.readonly = raw.readonly

  if (Number.isInteger(raw.paidPaymentId)) {
    payment.refNo = `P_${parseInt(raw.refNo)}`
    payment.paidPaymentId = parseInt(raw.paidPaymentId)
    payment.amount = raw.amount
    payment.payments = raw.payments
    payment.payment_details = (raw.payment_details || []).map((detail) =>
      transformPayment({ raw: detail, aliases, paymentCategories, units })
    )
    payment.category = 'Payment'
    if (raw.payment_details && raw.payment_details.length) {
      payment.total = raw.payment_details.reduce((a, b) => a + b.total, 0)
    } else {
      payment.total = 0
    }

    if (raw.payment_details) {
      if (raw.payment_details.length === 1) {
        payment.period =
          dayjs(raw.payment_details[0].startDate).format(MMDDYYYY) +
          ' - ' +
          dayjs(raw.payment_details[0].endDate).format(MMDDYYYY)
      } else if (raw.payment_details.length > 1) {
        payment.period = 'Multiple periods'
      } else {
        payment.period = 'No payments'
      }
    } else {
      payment.period = 'No payments'
    }
  }
  return payment
}

export default {
  namespaced: true,
  state: {
    payments: [],
    bedPayments: [],
    bedChartPayments: [],
    yearRentalPayments: [],
    tenantPayments: [],
    pendingRentalPayments: [],
    previewMultiplePayments: [],
    paymentRequests: [],
    paidPayments: []
  },
  getters: {
    getPayments: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      const units = rootGetters['units/getUnitsFlat']

      let parsedPayments = []
      // let payments = state.payments
      state.payments.map((raw) => {
        const paymentCategories =
          rootGetters['properties/getProperty'].payment_categories_details[0]
            .categories
        const payment = transformPayment({
          raw,
          aliases,
          paymentCategories,
          units
        })
        parsedPayments.push(payment)
      })

      return parsedPayments
      // return state.payments
    },
    getBedPayments: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      const units = rootGetters['units/getUnitsFlat']
      let parsedBedPayments = []

      state.bedPayments.map((raw) => {
        const paymentCategories =
          rootGetters['properties/getProperty'].payment_categories_details[0]
            .categories
        const payment = transformPayment({
          raw,
          aliases,
          paymentCategories,
          units
        })
        parsedBedPayments.push(payment)
      })

      return parsedBedPayments
    },
    getBedChartPayments: (state) => {
      let parsedBedChartPayments = []

      state.bedChartPayments.map((raw) => {
        let bedChartPayment = {}
        bedChartPayment.startDate = dayjs(raw.startDate).format(MMDDYYYY)
        bedChartPayment.diffDate = Math.ceil(
          parseInt(new Date(raw.startDate) - new Date(raw.date)) /
            (1000 * 60 * 60 * 24)
        )
        bedChartPayment.date = dayjs(raw.date).format(MMDDYYYY)
        // bedChartPayment.description = raw.description
        bedChartPayment.total = raw.total

        parsedBedChartPayments.unshift(bedChartPayment)
      })

      return parsedBedChartPayments
    },
    getHeaders: () => {
      return paymentHeaders.map((header) => {
        header.align = 'left'
        header.sortable = true
        header.filterable = true

        return header
      })
    },
    getUserPaymentHeaders: () => {
      return userPaymentHeaders.map((header) => {
        header.align = 'left'
        header.sortable = true
        header.filterable = true

        return header
      })
    },
    getYearRentalPayments: (state) => {
      return state.yearRentalPayments
    },
    getTenantPayments: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      let parsedPayments = []
      // let payments = state.payments
      state.tenantPayments.map((raw) => {
        const paymentCategories =
          rootGetters['properties/getProperty'].payment_categories_details[0]
            .categories
        const payment = transformPayment({ raw, aliases, paymentCategories })
        parsedPayments.push(payment)
      })

      return parsedPayments
    },
    getPendingRentalPayments: (state) => {
      return state.pendingRentalPayments.map((payment) => {
        payment.tenantName =
          payment.tenant_details.firstName && payment.tenant_details.lastName
            ? payment.tenant_details.firstName +
              ' ' +
              payment.tenant_details.lastName
            : payment.tenant_details.username
        payment.period =
          dayjs(payment.startDate).format(MMDDYYYY) +
          ' - ' +
          dayjs(payment.endDate).format(MMDDYYYY)
        return payment
      })
    },
    getPreviewMultiplePayments: (state) => {
      return state.previewMultiplePayments.map((payment) => {
        let props = payment.properties
        if (props && payment.message === 'SUCCESS') {
          props.valid = true
          props.selected = true
          props.unitName = props.bed.bedName
          props.period = `${props.startDate} - ${props.endDate}`
          props.parsedCategory = parsePaymentCategory(props.category)
          props.parsedStatus = parsePaymentStatus(props.status)
        } else {
          props = { valid: false }
          switch (payment.message) {
            case 'NO_TENANT':
              props.message = 'No tenant found'
              break
            case 'NO_UNIT':
              props.message = 'No unit found'
              break
            case 'MISSING_PARAMS':
              props.message = 'Incomplete fields'
              break
            default:
              props.message = 'Invalid entry'
              break
          }
        }
        return props
      })
    },
    getPaymentRequests: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      const units = rootGetters['units/getUnitsFlat']
      let parsedPaymentRequests = []
      state.paymentRequests.map((raw) => {
        const paymentCategories =
          rootGetters['properties/getProperty'].payment_categories_details[0]
            .categories
        const payment = transformPayment({
          raw,
          aliases,
          paymentCategories,
          units
        })
        parsedPaymentRequests.push(payment)
      })

      return parsedPaymentRequests
    },
    getPaidPayments: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      const units = rootGetters['units/getUnitsFlat']
      let parsedPaidPayments = []
      state.paidPayments.map((raw) => {
        const paymentCategories =
          rootGetters['properties/getProperty'].payment_categories_details[0]
            .categories

        // destructure raw
        const payment = transformPayment({
          raw,
          aliases,
          paymentCategories,
          units
        })
        parsedPaidPayments.push(payment)
      })

      return parsedPaidPayments
    },
    getPaymentRequestHeaders: () => {
      return paymentRequestHeaders.map((header) => {
        header.align = 'left'
        header.sortable = true
        header.filterable = true

        return header
      })
    },
    getPaidPaymentHeaders: () => {
      return paidPaymentHeaders.map((header) => {
        header.align = 'left'
        header.sortable = true
        header.filterable = true

        return header
      })
    }
  },
  mutations: {
    fetchPayments(state, payments) {
      state.payments = payments
    },
    fetchBedPayments(state, bedPayments) {
      state.bedPayments = bedPayments
    },
    fetchBedChartPayments(state, bedChartPayments) {
      state.bedChartPayments = bedChartPayments
    },
    fetchYearRentalPayments(state, yearRentalPayments) {
      state.yearRentalPayments = yearRentalPayments
    },
    fetchTenantPayments(state, tenantPayments) {
      state.tenantPayments = tenantPayments
    },
    fetchPendingRentalPayments(state, payments) {
      state.pendingRentalPayments = payments
    },
    fetchPreviewMultiplePayments(state, previewMultiplePayments) {
      state.previewMultiplePayments = previewMultiplePayments
    },
    fetchPaymentRequests(state, paymentRequests) {
      state.paymentRequests = paymentRequests
    },
    fetchPaidPayments(state, paidPayments) {
      state.paidPayments = paidPayments
    }
  },
  actions: {
    async fetchPaymentsAction(context, params) {
      const {
        page,
        limit,
        sortBy,
        sortDesc,
        search,
        status,
        categories,
        tags
      } = params
      let uri = `${
        process.env.VUE_APP_API_URL
      }/payment/search/grouped?limit=${limit}&page=${page - 1}`
      if (status) {
        uri += `&status=${status}`
      }
      if (sortBy) {
        uri += `&sortBy=${JSON.stringify(sortBy)}`
      }
      if (sortDesc) {
        uri += `&sortDesc=${JSON.stringify(sortDesc)}`
      }
      if (search) {
        uri += `&search=${JSON.stringify(search)}`
      }
      if (categories) {
        uri += `&categories=${encodeURIComponent(JSON.stringify(categories))}`
      }
      if (tags) {
        uri += `&tags=${JSON.stringify(tags)}`
      }
      const payments = await axios.get(uri, { withCredentials: true })

      context.commit('fetchPayments', payments.data.data)

      return {
        limit: limit,
        count: payments.data.count
      }
    },
    async fetchBedPaymentsAction(context, params) {
      const { page, limit, sortBy, sortDesc, tenantId, leaseId } = params
      if (!Number.isInteger(tenantId)) {
        return {
          limit: limit,
          count: 0
        }
      }
      let uri = `${
        process.env.VUE_APP_API_URL
      }/payment/search/grouped?limit=${limit}&page=${
        page - 1
      }&tenantId=${tenantId}&leaseId=${leaseId}`
      if (sortBy) {
        uri += `&sortBy=${JSON.stringify(sortBy)}`
      }
      if (sortDesc) {
        uri += `&sortDesc=${JSON.stringify(sortDesc)}`
      }
      const bedPayments = await axios.get(uri, { withCredentials: true })

      context.commit('fetchBedPayments', bedPayments.data.data)

      return {
        limit: limit,
        count: bedPayments.data.count
      }
    },
    async fetchBedChartPaymentsAction(context, params) {
      const { leaseId, tenantId } = params
      const bedChartPayments = await axios.get(
        `${process.env.VUE_APP_API_URL}/payment/search?limit=12&page=0&leaseId=${leaseId}&tenantId=${tenantId}&sortBy="endDate"&category=rental&status=paid|paid_late`,
        { withCredentials: true }
      )

      context.commit('fetchBedChartPayments', bedChartPayments.data.data)

      return {
        count: bedChartPayments.data.count
      }
    },
    async fetchYearRentalPaymentsAction(context) {
      const yearRentalPayments = await axios.get(
        `${process.env.VUE_APP_API_URL}/payment/yearRental`,
        { withCredentials: true }
      )

      context.commit('fetchYearRentalPayments', yearRentalPayments.data)

      return yearRentalPayments.data
    },
    async collectUtilities(context, params) {
      try {
        const form = new nodeFormData()
        const {
          tenantId,
          bedId,
          category,
          description,
          amount,
          startDate,
          endDate,
          attachments,
          leaseId,
          dueDate,
          confirmSendEmail,
          status
        } = params

        let items = [
          {
            item: category,
            description: description,
            quantity: 1,
            amount: amount
          }
        ]

        if (attachments) {
          await attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        form.append('tenantId', tenantId)
        if (bedId) {
          form.append('bedId', bedId)
        }
        form.append('category', category)
        form.append('description', description)
        // form.append('total', total)
        form.append('startDate', startDate)
        form.append('endDate', endDate)
        form.append('confirmSendEmail', confirmSendEmail)
        if (leaseId != null) {
          form.append('leaseId', leaseId)
        }
        if (dueDate) {
          form.append('dueDate', dueDate)
        }
        form.append('items', JSON.stringify(items))
        form.append('status', status)

        const pendingPayment = await axios.post(
          `${process.env.VUE_APP_API_URL}/payment/pending`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return Promise.resolve(pendingPayment)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select an image (.jpg, .png)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    },
    async setPaidAction(context, params) {
      try {
        const form = new nodeFormData()
        const {
          paymentId,
          amountPaid,
          datePaid,
          balanceUsed,
          total,
          attachments,
          currentAttachments,
          confirmSendEmail,
          description,
          deductFromSecDep
        } = params

        if (attachments) {
          await attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        form.append('amountPaid', amountPaid)
        form.append('datePaid', datePaid)
        form.append('balanceUsed', balanceUsed)
        form.append('total', total)
        form.append('description', description)
        form.append('deductFromSecDep', deductFromSecDep)
        form.append(
          'currentAttachments',
          JSON.stringify(currentAttachments || [])
        )
        form.append('confirmSendEmail', confirmSendEmail)

        const payment = await axios.put(
          `${process.env.VUE_APP_API_URL}/payment/${paymentId}/paid`,
          form,
          {
            withCredentials: true
          }
        )

        return Promise.resolve(payment)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select an image (.jpg, .png)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        } else {
          if (err.response.data === 'UPLOAD_ERROR') {
            response =
              'There is a problem with your file. Please select a different image.'
          }
        }
        return Promise.reject(response)
      }
    },
    async setVoidAction(context, params) {
      const { paymentId, creditBalance, confirmSendEmail } = params

      const payment = await axios.put(
        `${process.env.VUE_APP_API_URL}/payment/${paymentId}/void`,
        {
          creditBalance,
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return Promise.resolve(payment)
    },
    async createRentalPaymentAction(context, params) {
      try {
        const form = new nodeFormData()
        const {
          tenantId,
          bedId,
          amount,
          startDate,
          endDate,
          dueDate,
          datePaid,
          attachments,
          description,
          penalty,
          balanceUsed,
          rentFee,
          waived,
          leaseId,
          confirmSendEmail
        } = params
        let items = [
          {
            item: 'rental',
            description: description,
            quantity: 1,
            amount: rentFee
          }
        ]

        if (penalty) {
          form.append('status', 'paid_late')
          items.push({
            item: 'penalty',
            description: `Php ${penalty.amount} penalty for late payment`,
            quantity: penalty.latePaymentDays,
            amount: penalty.amount
          })
        } else if (waived) {
          form.append('status', 'waived')
          items.push({
            item: 'waivedFee',
            description: 'Waived Rental Fee',
            quantity: 1,
            amount: -rentFee
          })
        } else {
          form.append('status', 'paid')
        }

        // if(balanceUsed) {
        //   items.push({
        //     item: 'balanceUsed',
        //     description: balanceUsed>0?'Use Remaining Credits':'Debit Outstanding Balance',
        //     quantity: 1,
        //     amount: -balanceUsed
        //   })
        //   form.append('balanceUsed', balanceUsed)
        // }

        if (attachments) {
          await attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        form.append('tenantId', tenantId)
        form.append('bedId', bedId)
        form.append('category', 'rental')
        // form.append('total', total)
        form.append('startDate', startDate)
        form.append('endDate', endDate)
        form.append('dueDate', dueDate || '')
        form.append('datePaid', datePaid || '')
        form.append('items', JSON.stringify(items))
        form.append('amountPaid', amount)
        form.append('description', description)
        form.append('balanceUsed', balanceUsed)
        form.append('leaseId', leaseId)
        form.append('confirmSendEmail', confirmSendEmail)

        const pendingPayment = await axios.post(
          `${process.env.VUE_APP_API_URL}/payment`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return Promise.resolve(pendingPayment)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select an image (.jpg, .png)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    },
    async createGenericPaymentAction(context, params) {
      try {
        const form = new nodeFormData()
        const {
          tenantId,
          bedId,
          startDate,
          endDate,
          attachments,
          items,
          amountPaid,
          category,
          leaseId
        } = params

        if (attachments) {
          await attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        form.append('tenantId', tenantId)
        form.append('bedId', bedId)
        form.append('category', category)
        // form.append('total', total)
        form.append('startDate', startDate)
        form.append('endDate', endDate)
        form.append('items', JSON.stringify(items))
        form.append('amountPaid', amountPaid)
        form.append('leaseId', leaseId)
        // form.append('description', description)

        const pendingPayment = await axios.post(
          `${process.env.VUE_APP_API_URL}/payment`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return Promise.resolve(pendingPayment)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async fetchTenantPaymentsAction(context, params) {
      const { page, limit, tenantId, sortBy, sortDesc, search } = params
      let uri = `${
        process.env.VUE_APP_API_URL
      }/payment/search/grouped?limit=${limit}&page=${
        page - 1
      }&tenantId=${tenantId}`

      if (sortBy) {
        uri += `&sortBy=${JSON.stringify(sortBy)}`
      }
      if (sortDesc) {
        uri += `&sortDesc=${JSON.stringify(sortDesc)}`
      }
      if (search) {
        uri += `&search=${JSON.stringify(search)}`
      }

      const tenantPayments = await axios.get(uri, { withCredentials: true })

      context.commit('fetchTenantPayments', tenantPayments.data.data)

      return {
        limit: limit,
        count: tenantPayments.data.count
      }
    },
    async fetchPaymentByObjectIdAction(context, params) {
      const { objectId } = params
      let uri = `${process.env.VUE_APP_API_URL}/public/payment/objectId/${objectId}`

      const payment = await axios.get(uri)

      return payment.data
    },
    async generateReportAction(context, params) {
      try {
        const {
          tenantIds,
          categories,
          createdStartDate,
          createdEndDate,
          createdAllDates,
          paidStartDate,
          paidEndDate,
          paidAllDates,
          statuses,
          tags,
          fileType,
          paymentTypes
        } = params

        // push here will affect the model, so duplicate this
        const statusesToSend = [...statuses]

        if (statusesToSend.includes('void')) {
          statusesToSend.push('void_credit_balance')
        }
        if (statusesToSend.includes('paid')) {
          statusesToSend.push('paid_late')
        }

        const pendingPayment = await axios.post(
          `${process.env.VUE_APP_API_URL}/payment/report`,
          {
            tenantIds,
            categories,
            createdStartDate,
            createdEndDate,
            createdAllDates,
            paidStartDate,
            paidEndDate,
            paidAllDates,
            statuses: statusesToSend,
            fileType,
            tags,
            paymentTypes
          },
          {
            withCredentials: true,
            responseType: 'blob'
          }
        )
        FileDownload(pendingPayment.data, `Report.${fileType}`)

        return Promise.resolve(pendingPayment.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async fetchBalanceAction(context, params) {
      try {
        const { userId } = params

        const balance = await axios.get(
          `${process.env.VUE_APP_API_URL}/payment/balance/${userId}`,
          { withCredentials: true }
        )
        return Promise.resolve(balance.data.total)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async uploadMultiplePaymentsAction(context, params) {
      try {
        const form = new nodeFormData()
        const { files } = params

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        if (files) {
          await files.forEach((file) => {
            form.append('file', file)
          })
        }

        const uploadFile = await axios.post(
          `${process.env.VUE_APP_API_URL}/payment/previewMultiplePayments`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )
        const data = uploadFile.data
        context.commit('fetchPreviewMultiplePayments', data)
        return Promise.resolve(data)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select a valid CSV file (.csv)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    },
    async fetchCSVTemplate() {
      try {
        let uri = `${process.env.VUE_APP_API_URL}/public/template`
        let tenantsUri = `${process.env.VUE_APP_API_URL}/payment/tenantsCSV`
        const template = await axios.get(uri)
        const tenants = await axios.get(tenantsUri, {
          withCredentials: true
        })

        FileDownload(template.data, 'Template.csv')
        FileDownload(tenants.data, 'Tenants.csv')
        return Promise.resolve(template.data)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select a valid CSV file (.csv)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    },
    async updatePaymentRequest(context, params) {
      try {
        const form = new nodeFormData()
        const {
          paymentId,
          category,
          description,
          amount,
          startDate,
          endDate,
          attachments,
          leaseId,
          dueDate,
          currentAttachments,
          confirmSendEmail
        } = params
        let items = [
          {
            item: category,
            description: description,
            quantity: 1,
            amount: amount
          }
        ]

        if (attachments) {
          await attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        form.append('paymentId', paymentId)
        form.append('category', category)
        form.append('description', description)
        // form.append('total', total)
        form.append('startDate', startDate)
        form.append('endDate', endDate)
        form.append('leaseId', leaseId)
        form.append('dueDate', dueDate)
        form.append(
          'currentAttachments',
          JSON.stringify(currentAttachments || [])
        )
        form.append('items', JSON.stringify(items))
        form.append('confirmSendEmail', confirmSendEmail)

        const pendingPayment = await axios.put(
          `${process.env.VUE_APP_API_URL}/payment/update`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return Promise.resolve(pendingPayment)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select an image (.jpg, .png)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    },
    async fetchPendingRentalPaymentsAction(context) {
      let uri = `${process.env.VUE_APP_API_URL}/payment/pending/rentals`

      const payments = await axios.get(uri, { withCredentials: true })

      context.commit('fetchPendingRentalPayments', payments.data)
      return payments.data
    },
    async setCanceledAction(context, params) {
      const { paymentId, confirmSendEmail } = params

      const payment = await axios.put(
        `${process.env.VUE_APP_API_URL}/payment/${paymentId}/cancel`,
        { confirmSendEmail },
        {
          withCredentials: true
        }
      )

      return Promise.resolve(payment)
    },
    async fetchRentalsToMakeAction(context, params) {
      const { leaseId } = params

      const items = await axios.get(
        `${process.env.VUE_APP_API_URL}/payment/rentalsToMake/${leaseId}`,
        {
          withCredentials: true
        }
      )

      return Promise.resolve(items.data)
    },
    async fetchPropertyRentalsToCatchUpAction() {
      const items = await axios.get(
        `${process.env.VUE_APP_API_URL}/payment/propertyRentalsToCatchUp`,
        {
          withCredentials: true
        }
      )

      return Promise.resolve(items.data)
    },
    async fetchCalculatedPayments(context, params) {
      const { amount, leaseId } = params

      const items = await axios.get(
        `${process.env.VUE_APP_API_URL}/payment/combined/lease/${leaseId}`,
        {
          params: {
            amount: amount
          },
          withCredentials: true
        }
      )

      return Promise.resolve(items.data)
    },
    async fetchCombinedPaymentsTenant(context, params) {
      const { amount, tenantId } = params

      const items = await axios.get(
        `${process.env.VUE_APP_API_URL}/payment/combined/tenant/${tenantId}`,
        {
          params: {
            amount: amount
          },
          withCredentials: true
        }
      )

      return Promise.resolve(items.data)
    },
    async createCombinedPayments(context, params) {
      const form = new nodeFormData()
      const {
        totalAmountPaid,
        payments,
        tenantId,
        leaseId,
        balanceUsed,
        confirmSendEmail,
        datePaid,
        description,
        attachments = [],
        deductFromSecDep
      } = params

      for (let index in payments) {
        const payment = payments[index]
        form.append('payments', JSON.stringify(payment))

        if (payment.attachments) {
          await payment.attachments.map((file) => {
            form.append(`attachments_${payment.paymentId}`, file)
          })
        }
      }

      for (let attachment of attachments) {
        form.append('attachments_paid_payment', attachment)
      }

      form.append('totalAmountPaid', totalAmountPaid)
      form.append('balanceUsed', balanceUsed)
      form.append('tenantId', tenantId)
      form.append('confirmSendEmail', confirmSendEmail)
      form.append('datePaid', datePaid)
      form.append('description', description || '')
      form.append('deductFromSecDep', deductFromSecDep)
      if (leaseId != null) {
        form.append('leaseId', leaseId)
      }

      let uri = `${process.env.VUE_APP_API_URL}/payment/combined`

      const result = await axios.post(uri, form, {
        withCredentials: true
      })

      return Promise.resolve(result.data)
    },
    async setCanceledPaidPaymentAction(context, params) {
      const { paidPaymentId, confirmSendEmail } = params

      const payment = await axios.put(
        `${process.env.VUE_APP_API_URL}/payment/${paidPaymentId}/cancelPaid`,
        {
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return Promise.resolve(payment)
    },
    async setVoidPaidPaymentAction(context, params) {
      const { paidPaymentId, confirmSendEmail } = params

      const payment = await axios.put(
        `${process.env.VUE_APP_API_URL}/payment/${paidPaymentId}/voidPaid`,
        {
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return Promise.resolve(payment)
    },
    async createMultiplePaymentsAction(context, params) {
      const { payments } = params
      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/createMultiplePayments`,
        {
          payments: payments
        },
        {
          withCredentials: true
        }
      )

      return Promise.resolve(result.data)
    },
    async createPaymentCategory(context, params) {
      const { text } = params
      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/categories`,
        {
          text: text
        },
        {
          withCredentials: true
        }
      )

      return Promise.resolve(result.data)
    },
    async deletePaymentCategory(context, params) {
      const { value } = params
      const result = await axios.patch(
        `${process.env.VUE_APP_API_URL}/payment/categories`,
        {
          value: value
        },
        {
          withCredentials: true
        }
      )

      return Promise.resolve(result.data)
    },
    async approvePaymentRequestAction(context, params) {
      const { paymentId, confirmSendEmail } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/request/approve`,
        {
          paymentId,
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async rejectPaymentRequestAction(context, params) {
      const { paymentId } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/request/reject`,
        {
          paymentId
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async approvePaidPaymentAction(context, params) {
      const { paidPaymentId, confirmSendEmail } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/paid/approve`,
        {
          paidPaymentId,
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async rejectPaidPaymentAction(context, params) {
      const { paidPaymentId } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/paid/reject`,
        {
          paidPaymentId
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },

    async sendMonthlyStatementAction(context, params) {
      const { tenantId, date, sortBy } = params
      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/monthlyStatement`,
        {
          tenantId,
          date,
          sortBy
        },
        {
          withCredentials: true
        }
      )
      return Promise.resolve(result.data)
    },

    async sendBatchMonthlyStatementAction(context, params) {
      const { date, sortBy } = params
      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/monthlyStatement/batch`,
        {
          date,
          sortBy
        },
        {
          withCredentials: true
        }
      )
      return Promise.resolve(result.data)
    },

    async downloadMonthlyStatementAction(context, params) {
      const { tenantId, date, sortBy } = params
      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/monthlyStatement/download`,
        {
          tenantId,
          date,
          sortBy
        },
        {
          withCredentials: true,
          responseType: 'blob'
        }
      )

      FileDownload(result.data, `Report.pdf`)
    },
    async fetchPaymentRequestsAction(context, params) {
      const {
        page,
        limit,
        sortBy,
        sortDesc,
        search,
        status,
        categories,
        tags,
        tenantId
      } = params
      let uri = `${process.env.VUE_APP_API_URL}/payment/search/requests`

      const response = await axios.get(uri, {
        params: {
          status,
          sortBy,
          sortDesc,
          search,
          categories,
          tags,
          tenantId,
          limit,
          page: page - 1
        },
        withCredentials: true
      })

      const { payments, count } = response.data
      context.commit('fetchPaymentRequests', payments)

      return {
        limit,
        count
      }
    },
    async fetchPaidPaymentsAction(context, params) {
      const {
        page,
        limit,
        sortBy,
        sortDesc,
        search,
        status,
        categories,
        tags,
        tenantId
      } = params
      let uri = `${process.env.VUE_APP_API_URL}/payment/search/paid`

      const response = await axios.get(uri, {
        params: {
          status,
          sortBy,
          sortDesc,
          search,
          categories,
          tags,
          tenantId,
          limit,
          page: page - 1
        },
        withCredentials: true
      })

      const { payments, count } = response.data
      context.commit('fetchPaidPayments', payments)

      return {
        limit,
        count
      }
    },
    async updatePaidPayment(context, params) {
      try {
        const form = new nodeFormData()
        const {
          paidPaymentId,
          description,
          date,
          attachments,
          currentAttachments
        } = params

        if (attachments) {
          await attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        form.append('description', description)
        form.append('date', date)
        form.append(
          'currentAttachments',
          JSON.stringify(currentAttachments || [])
        )

        const pendingPayment = await axios.put(
          `${process.env.VUE_APP_API_URL}/payment/paid/update/${paidPaymentId}`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return pendingPayment
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select an image (.jpg, .png)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    },
    async batchApprovePaymentRequests(context, params) {
      const { paymentRequests, confirmSendEmail } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/request/batch/approve`,
        {
          paymentRequests: paymentRequests.map((paymentRequest) => {
            paymentRequest.status = paymentRequest.raw_status

            return paymentRequest
          }),
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async batchRejectPaymentRequests(context, params) {
      const { paymentRequests } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/request/batch/reject`,
        {
          paymentRequests: paymentRequests.map((paymentRequest) => {
            paymentRequest.status = paymentRequest.raw_status

            return paymentRequest
          })
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async batchApprovePaidPayments(context, params) {
      const { payments, confirmSendEmail } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/paid/batch/approve`,
        {
          paidPayments: payments.map((payment) => {
            payment.status = payment.raw_status

            return payment
          }),
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async batchRejectPaidPayments(context, params) {
      const { payments } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/paid/batch/reject`,
        {
          paidPayments: payments.map((payment) => {
            payment.status = payment.raw_status

            return payment
          })
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async generatePaidPaymentReportAction(context, params) {
      try {
        const {
          tenantIds,
          startDate,
          endDate,
          allDates,
          statuses,
          tags,
          fileType
        } = params

        const pendingPayment = await axios.post(
          `${process.env.VUE_APP_API_URL}/payment/paid/report`,
          {
            tenantIds,
            startDate,
            endDate,
            allDates,
            statuses,
            fileType,
            tags
          },
          {
            withCredentials: true,
            responseType: 'blob'
          }
        )
        FileDownload(pendingPayment.data, `PaidPayment-Report.${fileType}`)

        return Promise.resolve(pendingPayment.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async batchVoidPaymentRequests(context, params) {
      const { paymentRequests, confirmSendEmail } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/request/batch/void`,
        {
          paymentRequests: paymentRequests.map((paymentRequest) => {
            paymentRequest.status = paymentRequest.raw_status

            return paymentRequest
          }),
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async batchCancelPaymentRequests(context, params) {
      const { paymentRequests, confirmSendEmail } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/request/batch/cancel`,
        {
          paymentRequests: paymentRequests.map((paymentRequest) => {
            paymentRequest.status = paymentRequest.raw_status

            return paymentRequest
          }),
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async batchCancelPaidPayments(context, params) {
      const { payments, confirmSendEmail } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/paid/batch/cancel`,
        {
          payments: payments.map((payment) => {
            payments.status = payment.raw_status

            return payment
          }),
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async batchVoidPaidPayments(context, params) {
      const { payments, confirmSendEmail } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/payment/paid/batch/void`,
        {
          payments: payments.map((payment) => {
            payments.status = payment.raw_status

            return payment
          }),
          confirmSendEmail
        },
        {
          withCredentials: true
        }
      )

      return result.data
    }
  }
}
